"use strict"
exports.__esModule = true;
exports.HouzzIconConfig = {
  name: 'HouzzIcon',
  height: 512,
  width: 448,
  svgPath: 'M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z',
  yOffset: 0,
  xOffset: 0,
};
exports.HouzzIcon = require('../createIcon').createIcon(exports.HouzzIconConfig);
exports["default"] = exports.HouzzIcon;